<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M17.0586 23.1123C18.3648 23.1123 19.4336 22.0773 19.4336 20.8123V2.4123C19.4336 1.1473 18.3648 0.112305 17.0586 0.112305H9.93359V8.1623L6.96484 6.4373L3.99609 8.1623V0.112305H2.80859C1.50234 0.112305 0.433594 1.1473 0.433594 2.4123V20.8123C0.433594 22.0773 1.50234 23.1123 2.80859 23.1123H17.0586Z"
				:fill="color" 
			/>
		</svg>

	</div>
</template>

<script>
export default {
	name: 'IconSvgBookClosed',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>